export default {
    async getCoordinates() {
        let pos
        let coordinates = {}
        try {
            pos = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 6000, timeout: 5000, enableHighAccuracy: true })
            })
        } catch (e) {
            return coordinates
        }
        coordinates.latitude = pos.coords.latitude
        coordinates.longitude = pos.coords.longitude
        coordinates.accuracy = pos.coords.accuracy
        return coordinates
    }
}
